/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazyLucidIconComponent = lazyForPaint(
	() => import(/* webpackChunkName: "icon-lucid" */ './utils').then((m) => m.LucidIcon),
	{ moduleId: '@atlassian/rovo-connectors-config/lucid/icon' },
);

const LazyLucidSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-lucid-search-result" */ './utils').then(
			(m) => m.LucidSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/lucid/search-result-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const LucidIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyLucidIconComponent />
	</Suspense>
);

export const LucidSearchResultIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyLucidSearchResultIconComponent />
	</Suspense>
);
